var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col text-center alert alert-warning primary",attrs:{"id":"refineSearchMsg"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n  "),_c('a',{staticClass:"alert-link",attrs:{"href":"#"},on:{"click":_vm.clicked}},[_vm._v("Back to Top")])])
}
var staticRenderFns = []

export { render, staticRenderFns }